(function () {
    'use strict';

    angular
        .module('app')
        .controller('SchoolsAddController', SchoolsAddController);

    SchoolsAddController.$inject = ['debug', '$stateParams', 'API', '$state', 'i18n',];

    function SchoolsAddController(debug, $stateParams, API, $state, i18n) {
        var vm = this;
        vm.id = $stateParams.id;
        vm.isAdding = false;
        vm.add = add;
        vm.school = {
            status: 'unverified'
        };
        vm.loadingState = {
            'schoolIsLoading': false
        };

        function add() {
            if (!vm.isAdding) {
                vm.isAdding = true;

                var newSchool = new API.School(vm.school);

                var promise = newSchool.$save();

                promise.then(function (response) {
                    window.toast({ message: i18n.get('SAVED'), autoRemoveTime: 5000, type: 'success' });
                    $state.go('schools.edit', { id: response.id });
                }, function () {
                })
                .finally(function() {
                    vm.isAdding = false;
                });
            }
        }
    }
})();